export const setToken = (token, expiresIn) => {
  const expiresAt = Date.now() + expiresIn * 1000;
  localStorage.setItem("token", token);
  localStorage.setItem("expires_at", expiresAt.toString());
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const clearToken = () => {
  localStorage.removeItem("token");
};

export function isAccessTokenValid() {
  const token = getToken();
  const expiresAt = Number(localStorage.getItem("expires_at") || "0");
  return !!token && Date.now() < expiresAt;
}